import { FEATURES } from '@/config/featureConfig';

// LockInfo interface for menu items
interface LockInfo {
  requiredPackage: 'Professional' | 'Replenishment';
  benefits: string[];
  tooltipText?: string;
}

export const freeV1 = {
    data: [
      {
        section: 'stocky-migration',
        title: 'Switching from Stocky',
        icon: 'mdi-swap-horizontal',
        type: 'group',
        items: [
          {
            title: 'Master Guide',
            icon: 'mdi-book-open-page-variant-outline',
            type: 'single',
            link: '/stocky-switcher',
          },
          {
            title: 'Stocky Migration Tool',
            icon: 'mdi-database-import-outline',
            type: 'single',
            link: '/stocky-data-migration',
          },
        ],
      },
      {
        section: 'inventory-tracking',
        title: 'Inventory Tracking',
        icon: 'mdi-package-variant-closed',
        items: [
              {
                title: 'Inventory tracking overview',
                link: '/board/1460',
              },
              {
                title: 'Inventory on-hand',
                link: '/reports/31',
              },
              {
                title: 'Low stock',
                link: '/card/view/1276?report_query=eJztWG1v2zYQ_iuCgAEtYhXWi1-xL62bAcWaNkvSDkUQCLREJ1opUSUpN0aQ_76jJJsnWU5tZ-iX9YthHZ97J--OfLBVohi1p_a7bEkzxcXKuqA5o1ki71IgWHNByVcn5t8za76yzgWPi0hZn4lISKbsnh3dEaGuVrmWcfnp7Oz1xReg3hE50wv2VImC9mx5x7_XhAVhUlMoo5Gi8YyIeMZZkWbSnl4_2BlJtahakVbA49I-RdNr_WO9pTISSa4Snt3AekwUqfUreq85WJHIM5LnSXYLxPkqzGthj72NfORAJX-5IfxI4BqJpF3--clIqrWF8mtxkHklAxJ6QbmIqbD-KkBbolZGw3WyTlYocLJa4YhplKSEbancwd2l-y1RFOkVFTkEJbStrEI2NWE8Fv8pS5S0LjmLkXAJn-G32tkwJ4KkezrUwbmtTYOsHHyKCQ4lWVJBbimYmLBVWGhoWMo7xICnhWBbXsf_FBK2vVUcZZQkjMpQCZrFzzUNicIGvqcktq6SlFovwCb5ElkFuybmImSACBUg9rSgzdY4OGRB1cq6VDz6irdCSQ6lJgPjkrJ9d8IWY9euPucJPvqbbZ1r-p6aGjxYiSmkHQf3daQKwqxtzJ5ad_I3LYh4CvjuylGthaYIfDvMhCckYCPewuax-MLCfSUlSaaFoESXidIbDYnLGck0bt-cPyUDm3QG2tMi7YqesQhcOz423cwNG8j9HjaQ-2fY0MncFYfy1FkzviwL_Uq2olDFNdLLZXQPiEGbtSsCT2kHF47V3sHa5fvHXa1Vm1-d7CNy32Ts8nq3XjD8OL1bjFjvH8k9NJudWhd6-Ti9XaxdxXa2iljXDBFp-oHFtuRpt3bYQxJX83XH070OdoFsV_SoEND0otXOVrlhtB9venZKiSwEfWJuAunQ1jIJA2k10JlZUiqYeauuN7W9vhc4ruv0A1iBpojoA6fvOX1fi6ILUjAVCpLd6kU_BeIiYYoKPB__R-V1SVgByGvbDWzwlcMoQgAEvKwc5zpyg6L_gSrrkFFuo63fUnarfqhrffOAiKoCFYvN8Lymb5RAr0yWtKWJfuuYyXWa82TJVcjLawXQAVWa3biUXMItxrriudGueJ41dDKmFZbftQYJoWa0Qytsv0SqzxpaaUliezoY9uz3ZA5zy9QeAORzJRn-61iUiJFBuH0EgY8NZmwwHsZ4CDNBmjBmYDDDvsFo1wxIf-mwMU7i8vSU1zqUr9P7iBV6yeKFcvjCKfeiFTcqPSyFfBGibUrXbDiqGX9eUIeuceMDR16A4I2rnsF8oRKBVvD1pKubmf6qHKY33uEJGx-1tjPa4qYrWZHO4bx3OoNSe-L2-7_h7L4yqUPZPZk0UO6ryQblogSfjFuwsYGhAJ6MWrCRgaEYngxbsKGB-Qg2aMHMRncDBAtasMDABgjmt2C-gaGDdeK1YJ6BjRrhbcJcA8NZaKIMBqXAaYrqoxR4KAWO14KZFHgoBY7fgpkUeCgFTtCCmRR4KAXOoAUzKfBQCpxhC2ZS4KEUOKMWzKTAQylwxi2YSYGHUuBMWjC36yjemOck3Zq50O1715OS9S6FJm9OaVJ-bnea__PT0899n_l1Y64H5nqA2355-anX5F_PZT98LtPzokZV4yJUmYfyG2p-z06gUMhzKs5LwgCqu4SC9GalW3_3GbqpILq4AEg_mAPlVvAiL7nWH_W6vpJATC45ekxP4caQIMojxIawqGBEl8SUKpFEsuKFrQhqE8mz6lV2-qDBnHFxUTA0Zti-6w36wYQ4Cy8iTjAMIofM4ZYyHI_iaD7xPeqSMge60M4OvHD4jaH8d7s2Af6L2_kLbzDoWV7QL39erhdBQp08wb_b-1zM1h3FDoLRZO65vjN3x74TLAIP_nljuIxNRm7sDiIaDY725drvuUHzlvHm9Orv09MPnW7Vvj3HrfK6ks1qawsgTf3HfwGfhKg3',
              },
              {
                title: 'Out-of-stock',
                link: '/reports/288?report_query=eJzVWG1P6zYU_itRpEmbaK6aQAv0G4NNQrvcyyggXSEUmcQt3nXiXNvpqBD_fcdJW5-4SWmLtGlfEDl-zutj-5z61ddMc-qP_K-lDsQkUFok371rKdIy0crv-ckzkfp2XhjM-O7q6uzmG0ifiTo3C_5Iy5L2fPUs_l4IJoQrI6GcJpqm50Sm54KXWa780cOrn5PMmFp4MA5EagSXmmYP5o93QVUiWaGZyB9hPSWaLPxr-mI0eMnUFSkKlk9B-DSPi4Wxt97K_j2RjOTI_mwleM_gEomsjf-4s5YW3mL1vdwpvEoBGb2hQqZUen-W4I3pufXwwPIZzbWQ81jSgtOcqecMBE45UpqwjPA1lx3abb4viKbIr6zFMTihrrMa2fSE8dj8Xc608saCp8i4gs_4xyLZuCCSZFsm1KK57s2AvAJySgkuJZlRSaYUQmR8HpcGGlf2dglgsxEcy1n6V6lg23vlXkEpwqmKtaR5-tHQkCkc4GdKUu-WZdT7GWJSv6CoYNekQsYcELEGxJYRuGqNg0MmVM-9sblV8FaoxHF12YDijPJtd8KaYtuuvhYMH_3Vti6MfEtPDR3s5HJ5utoO7lmiS8K9dcyWXjv1mxEkIgN8-81Rr8X2EvixWwgbLOAgLmDzeGKCQr2hGWG5MYKIrogyGw2ZKzjJDW5bzjfZwCFdgfeszNqqZyOC1PavTbtyIwbyskUM5OUDMbQqt9WhOnXeuZhVF_1cOVWo65qY5aq6O9TAVW2rwCbvkMK-3ltU23L_2tVaTfj1yd6D-6ZiW9bdfiHw_fyuKWK_v7MXaDadXidmeT-_baptl-35POFtM0Ri5DtetpWO29phDyl8my87nul1sAuUe6MnpYSml8w7W-VK0X977PkZJaqUdMPcBNahreUKBtJ6oLOzpNIw89Zdb-RH_ego6J8G4RBWoCk25GEUhANjik5IyXUsST41i4cZCCeMayrxfLx_l5kRXgLqwe_7kJ2A4YMABtR4NcC1sIHq_YVqb5fhrdPZVHf4AljBZkLHoprwYQmAlb3G74Mx_KDwbkVhQ9CiyLHHM86Nz-p74UQBz9xJcjmUM6XvDbT2wlJ_NBj2_M_kCUaIkW-Yua8tw_-mIBXi2CLCPoLAxwpzYjERxkQIc4o8YczAYoZ9izGpWZD5MmXjgqTVRq5-YSHSfntJeGmWPIF_xKWNSxeWYjGJUTOlSzVc1Vx8rKjD0KbxRaAswPAq1chivlGFQHP42pjqary-rebaVXZ42EXZhG4yJuJmKnmZPcHRa00GUXsQ9vs_YXY_WeoQuwenDVT46XSFChHBBycO7MTCUAEPjh3YsYWhGh4MHdjQwg4RbODA7EYPjxDsyIEdWdgAwQ4d2KGFoYN1EDmwyMKOG-VtwkILwyw0URaDKAiapvqIgghREEQOzFIQIQqCQwdmKYgQBcGRA7MURIiCYODALAURoiAYOjBLQYQoCI4dmKUgQhQEJw7MUhAhCoJTBxa2HcVH-7JjuqSQppN2ve54lxn0W3tKWfWJjvP_6xXov__l9---qzSeBJ0Rfq2dbOlyTa8xzApJE6K0x2E486o73fvRMtQuYLGBLd45dh1uN5jojkhSIKek74RCMlGuPTN0DqXdFupZyQys9agEJ-y1-ob7ruczOCTqmsrrSjCAm03BYfx1btreOxV6rLHmhAHaPOCCZCpFWVTqy4_FuhmRoeeOBXrczWCCZUjy1rOvonRqhubYXC8QVEJ4UnJirouMaskSVZtMRAb7jSmR14-Ho9e3t38AjGCQeQ',
              },
              {
                title: 'Inventory remaining days',
                link: '/reports/212',
              },
              {
                title: 'Inventory movement',
                link: '/reports/291',
              },
              {
                title: 'Month-end inventory',
                link: '/reports/350',
              },
              {
                title: 'Inventory value',
                link: '/reports/595',
              },
        ],
      },

      {
        section: 'sales-analytics',
        title: 'Sales Analytics',
        icon: 'mdi-chart-box',
        items: [
        {
                title: 'Business overview',
                link: '/board/117',
        },
        {
          title: 'Sales overview',
          link: '/board/64',
        },
        {
          title: 'Daily sales',
          link: '/reports/measures/sales_overview?report_query=eJztVl1r2zAU%2FStGMOjAYUm2tGnethTKYP2AlL6EYlT7xhXIktBHuhDy33ev7NZKs47svXkIuUfnniNZvodsmRdeApuxCy7kJltwCY7lrHzi1t9tDK1g%2BcTdnBA28zZAztyTfu6AFZeOEJBQeqjm3FZzLUOjHJstt0zxhjRura5C6UlZVwT89NAs6Su7AFdaYbzQ6gHXK%2B55Z%2BzhN3XIINwVN0aoGsHHTWE6sV3%2BVj9beO6D6206auFe8OPlX3r%2B4hIFDjx8i%2F6HQ%2BxI9O9BVdr2ym2dXdPqUcLrVmB%2Fyyvhsytua6Gyk0urnSta8Et2Db6IN%2F6591zud3x6cycGbAnq0NzErqKJXekGomPWiZ6gY%2FuOZYNsfnO5eNf4jW0ZrAVVbg5895pS31enxOEVO1a9F0mUcd%2BpaKnro%2FWIy3YPOWuAu2CJ60i%2B0GuwawHPpCMaUA6nob3SipMMvosW3xcRNzAejr8NhtPBaIoreOP7%2BPlgdEoysOJB%2BsJyVdPi12GF6EpIDxYnE%2FdgxFr7QsfJQ0JQ2CIUEM1wy5u9AV7gxGd32vQH99oorNZcBiyX7LuU7KGru%2Bfg8NTynVdXOH9P1NZFVGw2Oc3ZL%2F4IElkTpNy3yvibHn5knPWM0TChYPHKmfacccoZJ5zzxCnlTHrO6bDn0NF6ElV0h05bf2MrepzsnD50LM2reNUxFiOrC8bCgsGGovwIx49w%2FAjHf4Wj4TV0uYRzso01m41yJnAk3C3Y2whMhu0M%2Fti0eUa%2FaV6witOHUG11MC%2FrsegIFMHB%2BYVO%2FsI0GJciQXZ5PyFQYyj7goIBXUsuyyA5TXUD3orStZKlbjA5hdMKY9vjFre73R8EUyGD',
        },
        {
          title: 'Sales by geography',
          link: '/reports/measures/sales_overview?report_query=eJztVl1r2zAU%2FStGMOjAYUm2dG3etgzKYP2AlL6EYlT5xhXIktBHuhDy33ev7NROso7svXkIvkfnnnNl6V68YUEGBWzK5lyBz1jOxDN34X5tCcTwmfsZIWwaXISc%2BWfz0gJLrjwhoEAEKGfclTOjYq09my42TPOaNO6cKaMIpGxKAn4GqBf0l%2F0AL5y0QRr9iOslD7w1DvCbMlSU%2FppbK3WF4NO6sK3YNj%2FUz%2BaBh%2Bg7m5Za%2BB1%2Buvwu5y8uSeDIIzTofzikjJ7%2BA%2BjSuE65ibMbWj1JeNUI7Je8lCG75q6SOju7csb7ogE%2FZTcQinTkHzvPxX7Gh4MzseAE6GNzm7KKOmX1C0iOWSt6ho5Zc8kG2ez2av6m8YGtiM6BFusj372kvu%2BrU8%2FhFTtVvRPpKWPdfVFhqpP1iMu2jzmrgfvoiOtJvjArcCsJL6Qja9Aeu6E5UiED6eBldHhhZKpgPBx%2FGQwvBqMLXMEj38cvB6Nz0oEljyoUjuuKFj8PS0SXUgVw2JpYhJUrEwqTWg8JUWOK1EA0yx2v9zp4ji2f3Rvb7TwYqzFacRUxXLBvSrHHNm5fhMdtqzfurvThgaiNiyzZdHKes1%2F8CRSyJkh5aJTxmd5%2BYnztGKNhj4LBK%2Bei44z7nHGPc9lz6nMmHed82HFoax2JIjpEb1y4dSW9TnZJP9qW4WU66zQXE6udjIUDiwmFeJ%2BO79PxfTr%2BazpaXkE7l7BPNilm01HOJLaEvwN3l4DJsOnB7%2BtmntEz9QtGqfsQqpyJdreegpZAMzj6MDe9b5gax6XsIdu86xCocCqHggYDugquRFScurqG4KTwjaQwNU5O6Y0ucMNY4ma7%2FQPA3yAL',
        },
        {
          title: 'Product sales',
          link: '/reports/measures/total_sales?report_query=eJzNVl1r2zAU%2FStCMOhYwpJs6Ufeuox1hbXrcNaXEIxqK45Alow%2BuoaQ%2F74r2Y7luIUUlm0vIbo695xry%2FdcbbBhhlM8wTNZoK8sW6GIcKrRnZKpTYzGPZysiDKzdeFQsFwRPXURPDHK0h7WK%2FmrCiwJ1y5COU0MTadEpVPJbS40nsw3WJDccVTUjlmmLnBtaD53P%2Bgz1YlihWFSLGA%2FJYZUwoY%2BuQxumb4hRcFEBsGHdVxUZNvePj%2BKDDFWNzIVNNZ1%2FHD6OucZFU%2FQ0TBl9BUKPiPgv6cilaphLtfo1u0eRPxYErRLXjKDbojKmEAnV0pqHZfB9%2BiWmtgf%2FdtGc97OeLN3JgVVCRVd8cJnxbnPCgvwiqgiPQHF6mPro%2Bn3q%2BhF4T3ZxCpFRbLu6LaSQt2dUqCwix3K3pAEzFB3SJrI7GA%2Bh8XbRQ%2FnlGir%2FFFKQ3isq0pTllOhoRXaXzr0l4Fuiw3zFYwGo4%2F9wUV%2FeA47cOSt%2BHDQH545KroklptYEZG5zQ%2BDFKJLxg1V0JpQRMEepYmlbz0AWAEpTFAHK4gieauDI2h5BIbRPLmRhYDVI%2BEWlnN8yTleVOvqRWh4bP7Ct8u0uXfQUoWleDI%2B7eFv5IFyQI0Bcl8yw3%2F39j3irEEMBwEEFjvMeYMZhZhRgLkIlELMuMGcDhqMe7QG5FbuELkkqT9X74EuUrtgrGgh4bySF50QXeckC0yEVcvgRdWhTqN57yh3u%2BZ0NIv9KZjRKJI8DT7%2BH5YImCZrH9%2FjTmkCRfIOvYOiOjFUmLlW6DRtaSCvatuwp%2F6KJQSVo7udQ9YaQTlx5Z8HuuozmX%2FUiRqqdzPyhC5zaVuVN8FDeQOakD1aMY9AX2jw0c934deJ7KX9D%2BPmn8%2FZ49wdjnrdOealzY03MMhquoEDb%2FwaT4Y9zMATNbTpnQ%2BMwec1mPWntRtibbtZlFvOP2HT3X0hkilpC4%2BuF9W%2Bm%2BtWm0gG9%2BIcRjALItte83g0g2EPTg7DBmpICE8sJ2565NQoluiSMpE5TGOmpYjhPUDBm%2B32N%2FGL8rM%3D',
        },
        {
          title: 'Inventory sales matching',
          link: '/reports/measures/sales_on_hand_inventory?report_query=eJztVk1PGzEQ%2FSsrn4OUpA2FvUEqVahFpQpwiaKV2R0Sq157ZY%2FTRlH%2Be2e8G9Yk0I9TL%2BSAMs9v3nzYM2QrUKEGkYuZ1OCztc%2BuzBoMWrfJriWWK2WWYiDKlXR4u2mYSeZK%2BikjIkcXYCD8yv7ogEepPSOgoUSoptJVU6tDbbzI51thZM0aN85WocTsqpZLYH1bMaw6s5Iou2h7SAflr2XTcD65aFr%2Foj3dDQ6Fe8krhHrOf7KP4EunGlTWLJ7HQPiJRyEeNkUXJdW%2Fl05Jk%2Bivn4A%2FCJqgdSI0%2B3zXi%2BzL8d%2FDP2UWHRLRr64C57OpDWmKc8twUTJ6ULkJ9QO4owiJQyp%2Fa1HqLL6URP2Ts9636IF6GZwDU26O9JGFCh%2BFEv07o5CUrK4S%2BW%2BB2qtwE%2FGDABWU9AL0kT5Ts71jGqF%2F3E%2BnfaSLEgPVd8z5y6iv%2Br%2Bcwb3UAX4Xfmr94X292tEXncVuMRA1SB8cO8d%2BF9YUK2mqQu2pHEHVYDwNRvu6%2BjftkYa6QBVTHw%2FH70%2BGZyejMzoBkniGn5%2BMTlkKHmXQWDhplnz4bsiX%2Bag00jvL55RQo9YWCxsHkQjBkIsywLRGOlk%2FWxQz2izZrW36PqFtDFnr2L18Li60FovO7rrkqScaXp4k5TE2vo2iKpFPTgfii3wATawJUdp74e98bZHxoWeMhgmFjCfOWc8Zp5xxwjlPIqWcSc85HfYcLq0nscUX6q3DOOiEnfOHy7Kyig8hrt%2FI6hZw4aAhBxrmtyX8toTflvD%2FWcINTUi38mgEt9EW%2BWggFA2FvwF3E4HJsB3vyw1vtsOud7PPI0TH%2FMuLkKWzoYn8vdGd8%2BoPHmc2%2BVVW02ZWCbKjwqUug5a8KWpAp0rf%2Bpa2pm2sPP27oNIpt%2B1u9wtQs3BL',
        },
        {
          title: 'Product profitability',
          link: '/reports/measures/profit_margin?report_query=eJztVttuGjEQ%2FZWVpUqptKhASxp4a6iUVm2aSKR5QdHK7A6LVa9t%2BZIWIf49M2bDmqCoyXt4QMz4zDnjyxyxYV54CWzCbrTJvol6lV1bvRQ%2Bu%2BS2FoqiKpTesZyVK279zdoQGsMVd1PKsIm3AXLmVvpvm1hy6SgDEkoP1ZTbaqplaJRjk%2FmGKd4QR0tNzLqixHcPzZy%2Bsq%2FgSiuMF1rd4XrFPW%2BFPfyjChmEu%2BTGCFVjcrEuTEu2zff8t9wKrhL%2B%2B33iP4QqSJkQzX787khaocL9Ca%2FqLBYkpOfcRsYj4sV%2B4RXkj0WJwOE9nlxY7VyxS37IfoEvZlyCe981MD%2BsePfk5A3YEtRxFyZWFU2sShuIio%2FP6QQVs6iY9bLp1cXsWeEnsmWwFlS5PtI9KEp190qJwj73UvaOJGHGvlPSUtcv5iMs297lrAHugoWjg0Ma0YBy%2BOQPXzTOkcepKryIPQz7w0%2B9%2FllvcIYroKrD%2FLg3OCUqWPIgfWG5qmnxY7%2FC7FJIDxZHENsw4l77QscRQ0BQWCIUEMxwy5uDSZ3haGdoEN3evTbU8j2XAcM5%2ByIlu2vj9igcblw%2B84yF87cE3amIik1Gpzn7yRcgETVCyO2OGX%2FT%2BUfE5w4x6CcQDPaYsw4zTDHDBDNOlFLMqMOc9jsMba0DUUTX6LT1V7ai42Rj%2BtC2NK%2FibUf%2Fi6jWAQsLBguK8s0F31zwzQXJY2po3QenYRNjNhnkTODDd9dgr2Ni1N9N2vmaTOb4atpBpEFBAP0PwUxtdTCx4jFo18l9g%2FMznfxHadAmRZLZ5t3bhhoN2RdkCNhHyWUZJKdpbsBbUbodZakbdEzhtCrwCLDpzXb7AKM%2BG%2BE%3D',
        },
        {
          title: 'Product returns',
          link: '/board/347',
        },
        ],
      },
      {
        section: 'supplier-management',
        title: 'Supplier management',
        icon: 'mdi-truck',
        type: 'group',
        items: [
          {
            title: 'Supplier list',
            icon: 'mdi-truck',
            type: 'single',
            link: '/suppliers',
          },
        ],
      },
      {
        section: 'my-account',
        title: 'My account',
        icon: 'mdi-account',
        items: [
          {
            title: 'My subscription',
            link: '/subscription',
            icon: 'mdi-credit-card-outline',
          },
          {
            title: 'My reports',
            icon: 'mdi-chart-timeline-variant',
            type: 'single',
            link: '/my-reports',
          },
          {
            title: 'My dashboards',
            icon: 'mdi-chart-box-outline',
            type: 'single',
            link: '/my-dashboards',
          },

          {
            title: 'Recently downloaded files',
            icon: 'mdi-download',
            type: 'single',
            link: '/download-manager',
          },
          {
            title: 'Importing status',
            link: '/importing-status',
            icon: 'mdi-database-import',
          },
          {
            title: 'Logout',
            link: '/logout',
            icon: 'mdi-logout',
          },
        ],
      },
    ],
};
